import { MenuConfig } from "./menu-config";

export const getMenuOptions = (menuToGenerate) => {
    let generatedMenu = {};
    Object.keys(menuToGenerate).forEach((menuCategory) => {
        generatedMenu[menuCategory] = menuToGenerate[menuCategory].map((name) => MenuConfig[name]);
    });
    return generatedMenu;
};